import Typography from "@/Utility/Typography";
import ToggleSwitch from "@/Utility/ToggleSwitch";
import Button from "@/Utility/Button/Button";

/**
 * Controlled notification preferences (values from GET/PATCH /projects/:id/settings).
 */
const NotificationSettings = ({
  value,
  onChange,
  onSave,
  saveDisabled = false,
  saving = false,
}) => {
  const v = value ?? {};
  const setField = (key, next) => {
    onChange?.({ ...v, [key]: next });
  };

  return (
    <div className="bg-surface-primary border border-border-primary rounded-md shadow-sm p-6 space-y-5">
      <div>
        <Typography variant="h5" className="mb-1">
          Notification Settings
        </Typography>
        <Typography variant="text2" className="text-text-secondary">
          Purpose: Keep users informed without noise.
        </Typography>
      </div>

      <div className="flex items-center gap-3">
        <Typography variant="text2" className="font-medium text-text-primary">
          Enable notifications
        </Typography>
        <ToggleSwitch
          checked={!!v.notifications_enabled}
          onChange={(c) => setField("notifications_enabled", c)}
          className="mb-2"
        />
      </div>

      <div
        className={`space-y-3 pl-5 ${!v.notifications_enabled ? "opacity-40 pointer-events-none" : ""}`}
      >
        <Typography variant="text2" className="font-medium text-text-secondary">
          Notify on
        </Typography>

        <div className="flex items-center gap-3">
          <ToggleSwitch
            checked={!!v.notify_on_issue_assigned}
            onChange={(c) => setField("notify_on_issue_assigned", c)}
            size="sm"
            disabled={!v.notifications_enabled}
          />
          <Typography variant="text2" className="text-text-primary">
            Issue assigned
          </Typography>
        </div>

        <div className="flex items-center gap-3">
          <ToggleSwitch
            checked={!!v.notify_on_status_changed}
            onChange={(c) => setField("notify_on_status_changed", c)}
            size="sm"
            disabled={!v.notifications_enabled}
          />
          <Typography variant="text2" className="text-text-primary">
            Status changed
          </Typography>
        </div>

        <div className="flex items-center gap-3">
          <ToggleSwitch
            checked={!!v.notify_on_comment_added}
            onChange={(c) => setField("notify_on_comment_added", c)}
            size="sm"
            disabled={!v.notifications_enabled}
          />
          <Typography variant="text2" className="text-text-primary">
            Comment added
          </Typography>
        </div>
      </div>

      <div className="space-y-1">
        <Typography variant="text2" className="font-medium text-text-primary">
          Email delivery
        </Typography>
        <Typography variant="text2" className="text-text-secondary">
          Email notifications only (no schemes)
        </Typography>
      </div>
      <div>
        <Button
          variant="primary"
          size="md"
          className="px-6"
          disabled={saveDisabled || saving}
          onClick={onSave}
        >
          {saving ? "Saving…" : "Save Changes"}
        </Button>
      </div>
    </div>
  );
};

export default NotificationSettings;
